import React from "react";

import Breadcrumbs from "../component/breadcrumbs";
import ContentArea from "../component/ContentArea";
import CustomHelmet from "../component/CustomHelmet";
import Intro from "../component/Intro";
import BaseContainer from "../component/layout/base-container";

export default function Impressum() {
  return (
    <>
      <CustomHelmet pageTitle="Über" />
      <Breadcrumbs
        listItems={[
          { name: "Home", url: "/" },
          { name: "Impressum", url: "/impressum" },
        ]}
      />
      <BaseContainer>
        <Intro title="Impressum" />
        <ContentArea>
          <div class="TextImage">
            <h2 class="TextImage--title " id="Herausgeber">
              Herausgeber
            </h2>

            <div class="TextImage--inner">
              <div class="TextImage--content richtext">
                <p>
                  <span class="p-given-name">Wida</span>{" "}
                  <span class="p-family-name">Wemmer-Rogh</span> (
                  <a href="mailto:wida.rogh@ife.uzh.ch">E-Mail</a>)<br />
                  <span className="p-given-name">Leonie</span>{" "}
                  <span className="p-family-name">Gossner</span> (
                  <a href="mailto:leonie.gossner@uzh.ch">E-Mail</a>)<br />
                  <span className="p-title">Prof. Dr.</span>{" "}
                  <span className="p-given-name">Anna-Katharina</span>{" "}
                  <span className="p-family-name">Praetorius</span> (
                  <a href="mailto:anna.praetorius@ife.uzh.ch">E-Mail</a>)
                </p>
              </div>
            </div>
          </div>

          <div class="TextImage">
            <h2 class="TextImage--title " id="Webmaster">
              Webmaster
            </h2>

            <div class="TextImage--inner">
              <div class="TextImage--content richtext">
                <p>
                  Oliver Kamer (
                  <a href="mailto:oliverluca.kamer@uzh.ch">E-Mail</a>)
                </p>
              </div>
            </div>
          </div>
        </ContentArea>
      </BaseContainer>
    </>
  );
}
